export default "__VITE_ASSET__6c1e4f45__"